import { EventTypeEnum } from '../../enums/event-type.enum';
import { ExportTypesEnum } from '../../enums/export-types.enum';
import { IBookedEventsByMonth, IMonthlyEventData } from '../../interfaces/event.interface';

export class SetCurrentEventType {
    public static readonly type = '[Event type] set';
    constructor(public currentEventType: EventTypeEnum) {}
}

export class SetEventsCurrentMonth {
    public static readonly type = '[Current month] set';
    constructor(public monthIndex: number) {}
}

export class ResetEventsData {
    public static readonly type = '[Events Data] reset';
}

export class ExportData {
    public static readonly type = '[Meals] export data';
    constructor(public payload: IExportData) {}
}

export class SetMealsEventCurrentMonth {
    public static readonly type = '[Events Data] set meals event for current month';
    constructor(public payload: { eventsData: IMonthlyEventData[]; bookedEvents: IBookedEventsByMonth[]; monthIndex: number }) {}
}

export class SetHomeworkEventCurrentMonth {
    public static readonly type = '[Events Data] set homework event for current month';
    constructor(public payload: { eventsData: IMonthlyEventData[]; bookedEvents: IBookedEventsByMonth[]; monthIndex: number }) {}
}

export interface IExportData {
    dataType: ExportTypesEnum;
    fileName: string;
    startDate?: string;
    endDate?: string;
    studentId?: number;
    paid?: number;
    period?: string;
    name?: string;
    education_level_id?: number;
    search?: string;
    meal_choices?: string[];
    homework_type?: number;
}
